module.exports = __webpack_public_path__ + "static/img/1_1_2_2.23c21588.jpg";